import { createContext, useContext, useMemo } from 'react';

const SiteContext = createContext();

const defaultSiteMeta = {
  siteName: 'bowwowbasket.com',
  firebaseSiteDocId: '',
  orderPrefix: 'BWB',
  address: {
    street: '1200 Bay Trail',
    city: 'Oakland',
    state: 'CA',
    zip: '94607',
    country: 'USA',
  },
  email: 'hello@bowwowbasket.com',
  tagline: 'Travel made simple — flights, stays, and packages in one place',
};

function resolveFirebaseSiteDocId(siteMeta) {
  const explicit = (siteMeta.firebaseSiteDocId || '').trim().toLowerCase().replace(/^www\./, '');
  if (explicit) return explicit;
  if (typeof window !== 'undefined') {
    const host = window.location.hostname?.toLowerCase() || '';
    const withoutWww = host.startsWith('www.') ? host.slice(4) : host;
    if (withoutWww && withoutWww !== 'localhost' && withoutWww !== '127.0.0.1') {
      return withoutWww;
    }
  }
  return siteMeta.siteName.toLowerCase().replace(/\s/g, '');
}

export const SiteProvider = ({ children, meta = {} }) => {
  const siteMeta = { ...defaultSiteMeta, ...meta };

  const firebaseSiteDocId = useMemo(
    () => resolveFirebaseSiteDocId(siteMeta),
    [siteMeta.firebaseSiteDocId, siteMeta.siteName]
  );

  const value = {
    siteName: siteMeta.siteName,
    firebaseSiteDocId,
    orderPrefix: siteMeta.orderPrefix || 'BWB',
    address: siteMeta.address,
    fullAddress: [
      siteMeta.address.street,
      `${siteMeta.address.city}, ${siteMeta.address.state} ${siteMeta.address.zip}`,
      siteMeta.address.country,
    ].join(', '),
    email: siteMeta.email,
    tagline: siteMeta.tagline,
  };

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
};

export default SiteContext;
